import React__default from 'react';
import { FormLabel } from '../FormLabel/FormLabel.es.js';
import { BooleanInput } from './BooleanInput.es.js';

const labeledBooleanInputRoot = "_labeled-boolean-input-root_rt5rq_1";
const styles = {
	labeledBooleanInputRoot: labeledBooleanInputRoot
};

const LabeledBooleanInput = ({ children, type, value = void 0, "aria-label": ariaLabel = void 0, id = void 0, isDisabled = void 0, isErrored = void 0, isRequired = void 0, name = void 0, checked = false, onChange = () => {
}, tabIndex = 0 }) => {
  return React__default.createElement(
    FormLabel,
    { isDisabled, isErrored, isRequired, isSelected: checked, justifyContent: "stretch" },
    React__default.createElement(
      "span",
      { className: styles.labeledBooleanInputRoot, "data-errored": isErrored ? "" : void 0, "data-zds": true },
      React__default.createElement(BooleanInput, { "aria-label": ariaLabel, checked, disabled: isDisabled, id, isErrored, name, onChange, tabIndex, type, value }),
      children
    )
  );
};

export { LabeledBooleanInput };
//# sourceMappingURL=LabeledBooleanInput.es.js.map
